export default {
  computed: {
    status () {
      const presenter = {
        label: 'Not Finalized',
        tooltip: 'This invoice has been registered, but because the order is not closed, is subject to change.',
        indicatorClass: 'has-text-grey',
        step: 0
      }
      // if the invoice is closed, but not acknowledged
      if (this.invoice.status === 'closed' && this.invoice.acknowledged_at === null) {
        presenter.label = 'Sent to Retailer'
        presenter.tooltip = 'This invoice has been sent to the retailer, but the retailer has not yet acknowledged receipt.'
        presenter.indicatorClass = 'has-text-warning'
      }
      // if the invoice is closed, but acknowledged
      if (this.invoice.status === 'closed' && this.invoice.acknowledged_at !== null) {
        presenter.label = 'Received by Retailer'
        presenter.tooltip = 'The retailer has received this invoice.'
        presenter.indicatorClass = 'has-text-success'
        presenter.step = 1
      }
      return presenter
    }
  }
}
